// Utils
import { getText } from 'i18n/intl';
import _ from 'lodash';
import { EReservationKind } from '@timeedit/types/lib/enums';
// Components
import { Segmented, TEDrawerSection, TEInput } from '@timeedit/ui-components';
// Types
import type { IProps } from './sections.interface';
// Styles
import './GeneralInfo.scss';

const GeneralInfo = (props: IProps) => {
  const { membership, onChange } = props;

  return (
    <TEDrawerSection label="General info">
      <div className="membership-info">
        <TEInput.Input
          label="Name"
          tooltip="Name"
          value={membership.name}
          onChange={(val) => onChange('name', val)}
          placeholder={getText('new_membership')}
          data-testid="membership-name"
        />
        <TEInput.LabelWrapper label="Property" tooltip="Property">
          <Segmented
            className="membership-info-reservation-kind-segmented"
            options={typeOptions}
            value={
              membership.reservationKind as unknown as
                | EReservationKind
                | undefined
            }
            onChange={(val) => onChange('reservationKind', val)}
          />
        </TEInput.LabelWrapper>
        <TEInput.PureText label="Id" tooltip="Id" value={`${membership.id}`} />
      </div>
    </TEDrawerSection>
  );
};

export default GeneralInfo;

const typeOptions = [EReservationKind.PHYSICAL, EReservationKind.ABSTRACT].map(
  (type) => ({ value: type, label: getText(type) })
);
